// Service pricing data in both languages
export const servicePricing = {
  hu: [
    { service: 'Lámpa felszerelés', price: '5,000 Ft / db', duration: '30 perc' },
    { service: 'Kapcsoló / konnektor csere', price: '4,000 Ft / db', duration: '20 perc' },
    { service: 'Biztosíték / kismegszakító csere', price: '6,000 Ft / db', duration: '30 perc' },
    { service: 'Kamerarendszer telepítés', price: '25,000 Ft-tól', duration: '2-4 óra' },
    { service: 'Hibaelhárítás, áramkimaradás', price: '8,000 Ft / óra', duration: 'Változó' }
  ],
  en: [
    { service: 'Lamp installation', price: '5,000 HUF / pc', duration: '30 min' },
    { service: 'Switch / outlet replacement', price: '4,000 HUF / pc', duration: '20 min' },
    { service: 'Fuse / circuit breaker replacement', price: '6,000 HUF / pc', duration: '30 min' },
    { service: 'Security camera installation', price: 'From 25,000 HUF', duration: '2-4 hours' },
    { service: 'Troubleshooting, power outage', price: '8,000 HUF / hour', duration: 'Variable' }
  ]
};

export const getServicePricing = (serviceKey, language) => {
  const pricingData = {
    electrical: {
      hu: [
        { service: 'Lámpa felszerelés', price: '5,000 Ft / db', duration: '30 perc' },
        { service: 'Kapcsoló / konnektor csere', price: '4,000 Ft / db', duration: '20 perc' },
        { service: 'Biztosíték / kismegszakító csere', price: '6,000 Ft / db', duration: '30 perc' },
        { service: 'Kamerarendszer telepítés', price: '25,000 Ft-tól', duration: '2-4 óra' },
        { service: 'Hibaelhárítás, áramkimaradás', price: '8,000 Ft / óra', duration: 'Változó' }
      ],
      en: [
        { service: 'Lamp installation', price: '5,000 HUF / pc', duration: '30 min' },
        { service: 'Switch / outlet replacement', price: '4,000 HUF / pc', duration: '20 min' },
        { service: 'Fuse / circuit breaker replacement', price: '6,000 HUF / pc', duration: '30 min' },
        { service: 'Security camera installation', price: 'From 25,000 HUF', duration: '2-4 hours' },
        { service: 'Troubleshooting, power outage', price: '8,000 HUF / hour', duration: 'Variable' }
      ]
    },
    plumbing: {
      hu: [
        { service: 'Csaptelep csere', price: '8,000 Ft / db', duration: '45 perc' },
        { service: 'WC tartály javítás', price: '7,000 Ft', duration: '30 perc' },
        { service: 'Radiátor légtelenítés', price: '3,000 Ft / db', duration: '15 perc' },
        { service: 'Szivárgás javítás', price: '10,000 Ft-tól', duration: '1-2 óra' },
        { service: 'Mosógép / mosogatógép bekötés', price: '9,000 Ft', duration: '1 óra' }
      ],
      en: [
        { service: 'Faucet replacement', price: '8,000 HUF / pc', duration: '45 min' },
        { service: 'Toilet tank repair', price: '7,000 HUF', duration: '30 min' },
        { service: 'Radiator bleeding', price: '3,000 HUF / pc', duration: '15 min' },
        { service: 'Leak repair', price: 'From 10,000 HUF', duration: '1-2 hours' },
        { service: 'Washing machine / dishwasher connection', price: '9,000 HUF', duration: '1 hour' }
      ]
    },
    kitchen: {
      hu: [
        { service: 'Konyhaszekrény összeszerelés', price: '5,000 Ft / elem', duration: '30-45 perc' },
        { service: 'Teljes konyha összeszerelés', price: '60,000 Ft-tól', duration: '1-2 nap' },
        { service: 'Szekrénysor összeszerelés', price: '40,000 Ft-tól', duration: '4-6 óra' },
        { service: 'Íróasztal / szék összeszerelés', price: '4,000 Ft / db', duration: '30 perc' },
        { service: 'Szagelszívó telepítés', price: '12,000 Ft', duration: '1-2 óra' }
      ],
      en: [
        { service: 'Kitchen cabinet assembly', price: '5,000 HUF / unit', duration: '30-45 min' },
        { service: 'Complete kitchen assembly', price: 'From 60,000 HUF', duration: '1-2 days' },
        { service: 'Cabinet set assembly', price: 'From 40,000 HUF', duration: '4-6 hours' },
        { service: 'Desk / chair assembly', price: '4,000 HUF / pc', duration: '30 min' },
        { service: 'Range hood installation', price: '12,000 HUF', duration: '1-2 hours' }
      ]
    },
    renovation: {
      hu: [
        { service: 'Festés (szoba)', price: '30,000 Ft-tól / szoba', duration: '1-2 nap' },
        { service: 'Glettelés', price: '2,500 Ft / m²', duration: 'Változó' },
        { service: 'Járólapozás', price: '4,000 Ft / m²', duration: 'Változó' },
        { service: 'Parketta lerakás', price: '3,500 Ft / m²', duration: 'Változó' },
        { service: 'Ajtó beépítés', price: '15,000 Ft / db', duration: '2-3 óra' },
        { service: 'Teljes lakásfelújítás', price: 'Árajánlat alapján', duration: '2-4 hét' }
      ],
      en: [
        { service: 'Painting (room)', price: 'From 30,000 HUF / room', duration: '1-2 days' },
        { service: 'Plastering', price: '2,500 HUF / m²', duration: 'Variable' },
        { service: 'Tiling', price: '4,000 HUF / m²', duration: 'Variable' },
        { service: 'Parquet flooring', price: '3,500 HUF / m²', duration: 'Variable' },
        { service: 'Door installation', price: '15,000 HUF / pc', duration: '2-3 hours' },
        { service: 'Complete home renovation', price: 'Quote based', duration: '2-4 weeks' }
      ]
    },
    gardening: {
      hu: [
        { service: 'Fűnyírás', price: '5,000 Ft-tól', duration: 'Változó' },
        { service: 'Sövénynyírás', price: '3,000 Ft / méter', duration: 'Változó' },
        { service: 'Zöld hulladék elszállítás', price: '10,000 Ft-tól', duration: 'Változó' },
        { service: 'Kerítés javítás', price: '15,000 Ft-tól', duration: '2-4 óra' }
      ],
      en: [
        { service: 'Lawn mowing', price: 'From 5,000 HUF', duration: 'Variable' },
        { service: 'Hedge trimming', price: '3,000 HUF / meter', duration: 'Variable' },
        { service: 'Green waste removal', price: 'From 10,000 HUF', duration: 'Variable' },
        { service: 'Fence repair', price: 'From 15,000 HUF', duration: '2-4 hours' }
      ]
    },
    it: {
      hu: [
        { service: 'Windows telepítés, beállítás', price: '12,000 Ft', duration: '2-3 óra' },
        { service: 'Vírusirtás, tisztítás', price: '10,000 Ft', duration: '1-2 óra' },
        { service: 'SSD beépítés, adatmásolás', price: '15,000 Ft', duration: '2-3 óra' },
        { service: 'Router telepítés, konfiguráció', price: '8,000 Ft', duration: '1 óra' },
        { service: 'Számítógép javítás', price: '8,000 Ft / óra', duration: 'Változó' },
        { service: 'Adatmentés', price: '20,000 Ft-tól', duration: '2-4 óra' }
      ],
      en: [
        { service: 'Windows installation, setup', price: '12,000 HUF', duration: '2-3 hours' },
        { service: 'Virus removal, cleaning', price: '10,000 HUF', duration: '1-2 hours' },
        { service: 'SSD installation, data transfer', price: '15,000 HUF', duration: '2-3 hours' },
        { service: 'Router installation, configuration', price: '8,000 HUF', duration: '1 hour' },
        { service: 'Computer repair', price: '8,000 HUF / hour', duration: 'Variable' },
        { service: 'Data backup', price: 'From 20,000 HUF', duration: '2-4 hours' }
      ]
    },
    digital: {
      hu: [
        { service: 'PowerPoint prezentáció', price: '15,000 Ft-tól / 10 dia', duration: '2-3 nap' },
        { service: 'Office oktatás (1 alkalom)', price: '12,000 Ft / 2 óra', duration: '2 óra' },
        { service: 'Weboldal tervezés', price: '80,000 Ft-tól', duration: '1-2 hét' },
        { service: 'AI konzultáció', price: '20,000 Ft / óra', duration: '1 óra' },
        { service: 'Önéletrajz készítés', price: '10,000 Ft', duration: '2-3 nap' },
        { service: 'LinkedIn profil optimalizálás', price: '15,000 Ft', duration: '2-3 nap' }
      ],
      en: [
        { service: 'PowerPoint presentation', price: 'From 15,000 HUF / 10 slides', duration: '2-3 days' },
        { service: 'Office training (1 session)', price: '12,000 HUF / 2 hours', duration: '2 hours' },
        { service: 'Website design', price: 'From 80,000 HUF', duration: '1-2 weeks' },
        { service: 'AI consultation', price: '20,000 HUF / hour', duration: '1 hour' },
        { service: 'CV creation', price: '10,000 HUF', duration: '2-3 days' },
        { service: 'LinkedIn profile optimization', price: '15,000 HUF', duration: '2-3 days' }
      ]
    }
  };

  return pricingData[serviceKey][language] || pricingData[serviceKey]['hu'];
};
